import { Button } from '@material-ui/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledCommercial = styled.div`
  dl {
    display: flex;
    flex-wrap: wrap;
    line-height: 1.5rem;
  }
  dl dt {
    background-color: rgba(198, 158, 97, 0.5);
    width: 31%;
    font-weight: bold;
    padding: 2%;
    margin-bottom: 5px;
  }
  dl dd {
    background-color: rgba(198, 158, 97, 0.2);
    width: 61%;
    padding: 2%;
    margin-bottom: 5px;
  }
  @media screen and (max-width: 751px) {
    dl dt,
    dl dd {
      width: 100%;
      padding: 10px;
    }
    dl dt {
      margin-bottom: 0px;
    }
  }
  .linkIndex {
    text-align: center;
    margin: 20px auto 0px auto;
  }
`;

/**
 * 特定商取引に関する法律に基づく表記ページ
 */
const Commercial: FC = () => {
  return (
    <StyledCommercial>
      <h2>特定商取引に関する法律に基づく表記</h2>
      <dl>
        <dt>販売業者</dt>
        <dd>一般社団法人 北海道国際流通機構</dd>
        <dt>販売責任者</dt>
        <dd>代表理事 鳥取 義之</dd>
        <dt>販売業者の住所</dt>
        <dd>
          〒060–0052
          <br />
          札幌市中央区南2条東1丁目1−12 フラーテ札幌4F
        </dd>

        <dt>問い合わせ</dt>
        <dd>
          souseimarche@hi-do.or.jp
          <br />
          <small>
            ※決済や発送及び不具合等に関するお問い合わせ以外はお答えしかねる場合がございます。
            <br />
            あらかじめご了承ください。
          </small>
        </dd>

        <dt>お支払い金額</dt>
        <dd>
          表示商品代金（税込）
          <br />
          ※送料無料（当社が負担いたします）
        </dd>

        <dt>消費税</dt>
        <dd>表示商品代金には８％の消費税が含まれています。</dd>
        <dt>支払い方法</dt>
        {process.env.REACT_APP_SHOPIFY_COD_FLG === '1' ? (
          <>
            <dd>
              ・クレジットカード（JCB、Visa、Mastercard、American
              Express、ダイナースクラブ、Discover）
              <br />
              ・代金引換（e-コレクト 現金払い 手数料無料）
              <br />
              による支払い
              <br />
              ※代金引換の場合、商品が到着した際に配達員に代金をお支払いください。
              <br />
              <br />
              お支払い方法は現金のみ可能です。また代金引換で購入の際は、配達日時の変更ができません。
              （不在配達伝票からの再配達の日時指定は可能です。）
              <br />
              <br />
              代金引換で、請求先住所と配達先住所の異なる情報を入力して購入の場合、注文をお受けできません。
              代金引換で購入完了した場合、事業者側でキャンセルさせていただきます。
            </dd>
            <dt>領収書</dt>
            <dd>
              販売業者側で領収書の発行は行っておりません。それぞれの購入方法で発行される「利用明細書」「お客様控え」などが法規上の正式な領収書となります。
              <br />
              <br />
              クレジットカード：クレジットカード会社からの利用明細書、もしくは御注文時のメール控えが領収書となります。
              ※クレジットカードの場合、直接の現金の授受にあたらない（カード会社による立替払い）のため販売事業者側に領収書の発行義務はございません。
              <br />
              <br />
              代金引換：荷物お届け時に配送業者が発行する送り状伝票の「お客様控え」が領収書となります。お届け先のお名前が領収書の宛名となります。
            </dd>
            <dt>配送業者</dt>
            <dd>ヤマト運輸株式会社</dd>
            <dt>商品発送</dt>
            <dd>ご注文から10日以内に発送します。</dd>
            <dt>返品・キャンセル等</dt>
            <dd>
              商品の交換又は返品は商品の性質上、原則お受け致しません。
              <br />
              <br />
              ただし不良商品（訳あり商品は除く）、又は注文と異なる商品が到着した場合のみ、交換・返品の受付をします。
              <br />
              この場合、購入者は商品到着後３日以内にメールから当社へ通知するものとし、当社は良品の注文商品と交換します。
              <br />
              また、当該商品の返送及び再送に要する送料等は、当社にて負担するものとします。
              <br />
              <br />
              返品商品到着後３日以内に返金処理を行います。クレジットカードで決済の場合は、クレジットカード会社の返金処理に従い行うため、返金が決済月と異なる場合がございます。
              <br />
              また代金引換で購入の場合は、ご指定口座にお振込し返金いたします。
              <br />
              <br />
              商品をお届け先にて受け取りを拒否された場合でも原則、購入金額を請求させていただきます。
              <br />
              <br />
              ※購入完了時、配送先情報で登録いただいたメールアドレスに注文内容確認メールが送られますが、主に携帯キャリアメールの「なりすましメールフィルター」の設定によりメールが届かない場合があります。「なりすましメールフィルター」の設定を外すもしくは、携帯キャリアメール以外のメールアドレスでご登録をお勧めいたします。
            </dd>
          </>
        ) : (
          <>
            <dd>
              クレジットカード（JCB、Visa、Mastercard、American
              Express、ダイナースクラブ、Discover）
              <br />
              による支払い
            </dd>
            <dt>領収書</dt>
            <dd>
              販売業者側で領収書の発行は行っておりません。それぞれの購入方法で発行される「利用明細書」「お客様控え」などが法規上の正式な領収書となります。
              <br />
              <br />
              クレジットカード：クレジットカード会社からの利用明細書、もしくは御注文時のメール控えが領収書となります。
              ※クレジットカードの場合、直接の現金の授受にあたらない（カード会社による立替払い）のため販売事業者側に領収書の発行義務はございません。
            </dd>
            <dt>配送業者</dt>
            <dd>ヤマト運輸株式会社</dd>
            <dt>商品発送</dt>
            <dd>ご注文から10日以内に発送します。</dd>
            <dt>返品・キャンセル等</dt>
            <dd>
              商品の交換又は返品は商品の性質上、原則お受け致しません。
              <br />
              <br />
              ただし不良商品（訳あり商品は除く）、又は注文と異なる商品が到着した場合のみ、交換・返品の受付をします。
              <br />
              この場合、購入者は商品到着後３日以内にメールから当社へ通知するものとし、当社は良品の注文商品と交換します。
              <br />
              また、当該商品の返送及び再送に要する送料等は、当社にて負担するものとします。
              <br />
              <br />
              返品商品到着後３日以内に返金処理を行います。クレジットカードで決済の場合は、クレジットカード会社の返金処理に従い行うため、返金が決済月と異なる場合がございます。
              <br />
              <br />
              ※購入完了時、配送先情報で登録いただいたメールアドレスに注文内容確認メールが送られますが、主に携帯キャリアメールの「なりすましメールフィルター」の設定によりメールが届かない場合があります。「なりすましメールフィルター」の設定を外すもしくは、携帯キャリアメール以外のメールアドレスでご登録をお勧めいたします。
            </dd>
          </>
        )}
      </dl>
      <div className="linkIndex">
        <Button variant="contained" color="primary" component={Link} to="/">
          前のページへ戻る
        </Button>
      </div>
    </StyledCommercial>
  );
};

export default Commercial;
